<script>
  // import input formatting functions
  import { formatCurrency, formatPercentage } from '../util';
  // calculate payment function
  import calculateMortgagePayment from './calculateMortgagePayment';
  // import calculator base components
  import CalculatorDisclaimer from '../CalculatorDisclaimer.svelte';
  import CalculatorFieldError from '../CalculatorFieldError.svelte';
  import CalculatorHeader from '../CalculatorHeader.svelte';
  import CalculatorSubmitInput from '../CalculatorSubmitInput';

  // company prop for passing to Disclaimer
  export let company;

  // fields
  let totalHomeLoanAmount = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let downpayment = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let annualInterestRate = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let termOfTheLoan = {
    value: '30',
    error: false,
    errorMessage: 'Please select the Term of the Loan',
  };
  let taxes = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };

  let homeOwnersInsurance = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };

  let mortgageInsurance = {

    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
    
  let hoa = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };

  
  let showAmortizationSchedule = false;

  // result values
  let payment = 0;
  let amortizationSchedule = {};
  let finalLoanAmount = 0;

  // has result been calculated?
  let calculated = false;

  // format percentage for annualInterestRate and update value
  function formatAnnualInterestRate() {
    // if no input entered, exit
    if (annualInterestRate.value === '') return;

    const formattedPercentage = formatPercentage(annualInterestRate.value);

    annualInterestRate.value = formattedPercentage;
  }

  // reactive statement to format input values when they change
  $: if (totalHomeLoanAmount.value !== '')
    totalHomeLoanAmount.value = formatCurrency(totalHomeLoanAmount.value);

    $: if (downpayment.value !== '')
    downpayment.value = formatCurrency(downpayment.value);

  // do required fields have a value?
  $: if (totalHomeLoanAmount.value !== '' && totalHomeLoanAmount.value !== '$0')
    totalHomeLoanAmount.error = false;

  $: if (
    annualInterestRate.value !== '' &&
    annualInterestRate.value !== '0.000%'
  )
    annualInterestRate.error = false;

    $: if (mortgageInsurance.value !== '')
    mortgageInsurance.value = formatCurrency(mortgageInsurance.value);
     $: if (taxes.value !== '')
    taxes.value = formatCurrency(taxes.value)
     $: if (homeOwnersInsurance.value !== '')
    homeOwnersInsurance.value = formatCurrency(homeOwnersInsurance.value)
     $: if (hoa.value !== '')
    hoa.value = formatCurrency(hoa.value)

  function setCalculatedAndCalculate() {
    if (totalHomeLoanAmount.value === '' || totalHomeLoanAmount.value === '$0')
      totalHomeLoanAmount.error = true;

    if (
      annualInterestRate.value === '' ||
      annualInterestRate.value === '0.000%'
    )
      annualInterestRate.error = true;

    if (
      totalHomeLoanAmount.value === '' ||
      totalHomeLoanAmount.value === '$0' ||
      annualInterestRate.value === '' ||
      annualInterestRate.value === '0.000%'
    ) totalHomeLoanAmount.error = true;


    if (totalHomeLoanAmount.error || annualInterestRate.error || downpayment.error) return;

    calculated = true;
  

    let additionalItems =  {
      taxes: taxes.value,
      homeOwnersInsurance: homeOwnersInsurance.value,
      mortgageInsurance: mortgageInsurance.value,
      hoa: hoa.value
    }
      console.log(totalHomeLoanAmount.value,
      annualInterestRate.value,
      termOfTheLoan.value,
      additionalItems,
      downpayment.value)
    
    console.log(additionalItems)
    const calculatedMortgagePayment = calculateMortgagePayment(
      totalHomeLoanAmount.value,
      annualInterestRate.value,
      termOfTheLoan.value,
      additionalItems,
      downpayment.value
    );

    payment = calculatedMortgagePayment[0]
    amortizationSchedule = calculatedMortgagePayment[1];
    finalLoanAmount = calculatedMortgagePayment[2];
  }
</script>

<div>
  <CalculatorHeader
    title="Mortgage Payment Calculator"
    subtitle="Estimate Your Monthly Mortgage Payment" />
  <form on:submit|preventDefault={setCalculatedAndCalculate}>
    <div class="bg-gray-efftwo px-16 py-8">
      <div class="calculator-input-fields-wrapper">
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0">
          <label for="totalHomeLoanAmount" class="block">
            Estimated Home Price
          </label>
          <input
            type="text"
            id="totalHomeLoanAmount"
            name="totalHomeLoanAmount"
            placeholder="$250,000"
            bind:value={totalHomeLoanAmount.value}
            class="mt-2" />
          <CalculatorFieldError field={totalHomeLoanAmount} />
        </div>
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0 ">
          <label for="downpayment" class="block">
            Down Payment Amount
          </label>
          <input
            type="text"
            id="downpayment"
            name="downpayment"
            placeholder="$25,000"
            bind:value={downpayment.value}
            class="mt-2" />
          <CalculatorFieldError field={downpayment} />
        </div>
        <div class="calculator-field -mb-12 lg:mb-0">
          <label for="annualInterestRate" class="block">
            Annual Interest Rate
          </label>
          <input
            type="text"
            id="annualInterestRate"
            name="annualInterestRate"
            placeholder="3.500%"
            on:blur={formatAnnualInterestRate}
            bind:value={annualInterestRate.value}
            class="mt-2" />
          <CalculatorFieldError field={annualInterestRate} />
        </div>
        <div class="calculator-field lg:mr-16 mb-12 lg:mb-0">
          <label for="termOfTheLoan" class="block">Term of the Loan</label>
          <select
            id="termOfTheLoan"
            name="termOfTheLoan"
            bind:value={termOfTheLoan.value}
            class="mt-2"
            required>
            <option value="30" selected>30 Years</option>
            <option value="25">25 Years</option>
            <option value="20">20 Years</option>
            <option value="15">15 Years</option>
            <option value="10">10 Years</option>
            <option value="5">5 Years</option>
          </select>
        </div>
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0">
          <label for="taxes" class="block">
            Monthly Real Estate Taxes
          </label>
          <input
            type="text"
            id="taxes"
            name="taxes"
            placeholder="$500"
            bind:value={taxes.value}
            class="mt-2" />
          <CalculatorFieldError field={taxes} />
        </div>
        <div class="calculator-field -mb-12 lg:mb-0">
          <label for="homeOwnersInsurance" class="block">
            Monthly Home Owners Insurance
          </label>
          <input
            type="text"
            id="homeOwnersInsurance"
            name="homeOwnersInsurance"
            placeholder="$100"
            bind:value={homeOwnersInsurance.value}
            class="mt-2" />
          <CalculatorFieldError field={homeOwnersInsurance} />
      </div>
       <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0">
          <label for="mortgageInsurance" class="block">
            Monthly Mortgage Insurance
          </label>
          <input
            type="text"
            id="mortgageInsurance"
            name="mortgageInsurance"
            placeholder="$100"
            bind:value={mortgageInsurance.value}
            class="mt-2" />
          <CalculatorFieldError field={mortgageInsurance} />
      </div>
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0">
            <label for="hoa" class="block">
              Monthly HOA
            </label>
            <input
              type="text"
              id="hoa"
              name="hoa"
              placeholder="$100"
              bind:value={hoa.value}
              class="mt-2" />
            <CalculatorFieldError field={hoa} />
        </div>
      </div>
    </div>
    <CalculatorSubmitInput />
  </form>

  <div class="mt-10">
    {#if calculated}
      <h3
        class="calculator-result-title text-white font-medium mb-0 py-8 bg-black
        lg:font-normal">
        Loan Summary
      </h3>
      <div class="calculator-results-wrapper mt-0">
        <div
          class="flex flex-col justify-between p-8 md:flex-row md:flex-wrap
          lg:px-16 lg:py-8 lg:w-4/5">
          <div class="mb-16 md:mb-0 md:w-1/2 lg:w-2/5">
            <p class="calculator-result-subtitle">
              Monthly Payment
            </p>
            <p class="calculator-result-result py-4">${payment}</p>
            <!-- <p class="text-14 text-center font-light lg:text-left">
              (Insurance and taxes not included)
            </p> -->
          </div>
          <div class="md:w-1/2 lg:w-2/5">
            <p class="calculator-result-subtitle">Loan Amount</p>
            <p class="calculator-result-result py-4">
              {finalLoanAmount}
            </p>
          </div>
        </div>
        <div
          class="flex flex-col justify-between p-8 md:flex-row md:flex-wrap
          lg:px-16 lg:py-8 lg:w-4/5">
          <div class="mb-16 md:mb-0 md:w-1/2 lg:w-2/5">
            <p class="calculator-result-subtitle">Interest Rate</p>
            <p class="calculator-result-result py-4">
              {annualInterestRate.value}
            </p>
          </div>
          <div class="mb-16 md:mb-0 md:w-1/2 lg:w-2/5">
            <p class="calculator-result-subtitle">Term of the Loan</p>
            <p class="calculator-result-result py-4">
              {termOfTheLoan.value} years
            </p>
          </div>
        </div>
        <div class="text-center lg:text-left lg:px-16">
          <input
            type="checkbox"
            id="showAmortizationSchedule"
            name="showAmortizationSchedule"
            bind:checked={showAmortizationSchedule}
            class="form-checkbox"
            tabindex="0" />
          <label for="showAmortizationSchedule">
            Show Amortization Schedule
          </label>
          <CalculatorDisclaimer {company} />
        </div>
        {#if showAmortizationSchedule}
          <div class="pt-10 pb-4 lg:px-16">
            <h3 class="text-21 text-center lg:text-27 lg:text-left">
              Amortization Schedule
            </h3>
             <!-- <p class="text-14 text-center font-light lg:text-left">
              (Insurance and taxes not included)
            </p> -->
            <div
              class="calculator-table-wrapper border border-blue-primary mt-10
              overflow-y-scroll lg:w-4/5">
              <table class="w-full">
                <thead>
                  <tr class="text-white text-12 md:text-16 lg:text-18">
                    <th class="bg-blue-primary p-4 sticky top-0 lg:p-0 lg:py-4">
                      Year
                    </th>
                    <th class="bg-blue-primary p-4 sticky top-0 lg:p-0 lg:py-4">
                      Month
                    </th>
                    <th class="bg-blue-primary p-4 sticky top-0 lg:p-0 lg:py-4">
                      Interest Payment
                    </th>
                    <th class="bg-blue-primary p-4 sticky top-0 lg:p-0 lg:py-4">
                      Principal Payment
                    </th>
                    <th class="bg-blue-primary p-4 sticky top-0 lg:p-0 lg:py-4">
                      Loan Balance
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {#each amortizationSchedule as payment, i}
                    {#if i !== 0}
                      <tr
                        class="text-center text-12 md:text-16 lg:text-18 {i % 2 === 0 ? 'bg-gray-beethree' : null}">
                        <td class="p-4 lg:p-0 lg:py-4">{payment.year}</td>
                        <td class="p-4 lg:p-0 lg:py-4">{payment.month}</td>
                        <td class="p-4 lg:p-0 lg:py-4">${payment.interest}</td>
                        <td class="p-4 lg:p-0 lg:py-4">${payment.principal}</td>
                        <td class="p-4 lg:p-0 lg:py-4">
                          ${payment.currentBalance}
                        </td>
                      </tr>
                    {/if}
                  {/each}
                </tbody>
              </table>
            </div>
          </div>
        {/if}
      </div>
    {/if}
  </div>
</div>



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/mortgagePaymentCalculator/MortgagePaymentCalculator.svelte